import { call } from 'redux-saga/effects';

import customWebStylesResource from '@lib/resources/customWebStylesResource';

import { PUBLISH_CUSTOM_WEB_STYLES } from '@lib/actions/actionTypes';

import sagaFetch from './sagaFetch';

// bind resource generator
const publish = sagaFetch.bind(null, PUBLISH_CUSTOM_WEB_STYLES, customWebStylesResource.publish);

export default function* sagaPublishCustomWebStyles(action) {
  const { id } = action;
  yield call(publish, { id });
}
